import { ReactNode } from 'react';

import {
  Actionsheet,
  ActionsheetContent,
  ActionsheetDragIndicatorWrapper,
  ActionsheetDragIndicator,
  ActionsheetItem,
  ActionsheetScrollView,
  ActionsheetBackdrop,
} from '@/components/ui/actionsheet';
import { Button, ButtonText } from '@/components/ui/button';
import { Text } from '@/components/ui/text';
import { VStack } from '@/components/ui/vstack';

interface MultiSelectActionsheetProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}

export function MultiSelectActionsheet({
  isOpen,
  onClose,
  title,
  children,
}: MultiSelectActionsheetProps) {
  return (
    <Actionsheet isOpen={isOpen} onClose={onClose}>
      <ActionsheetBackdrop />
      <ActionsheetContent className="p-2.5">
        <ActionsheetDragIndicatorWrapper>
          <ActionsheetDragIndicator />
        </ActionsheetDragIndicatorWrapper>

        <VStack className="w-full px-4 py-3">
          <Text className="text-center font-semibold text-base text-typography-900">{title}</Text>
        </VStack>

        <ActionsheetScrollView className="max-h-[65vh]">{children}</ActionsheetScrollView>

        <ActionsheetItem>
          <Button onPress={onClose} className="flex-1" action="primary" variant="solid">
            <ButtonText>Done</ButtonText>
          </Button>
        </ActionsheetItem>
      </ActionsheetContent>
    </Actionsheet>
  );
}
